// assets/ajaxinate-patch.js
// Ajaxinate v2.0.4 patch (final):
// - Re-query live nodes after each append
// - Proactive viewport check after re-init
// - Always re-init even if callback throws
(function () {
  if (!window.Ajaxinate) return;

  // ---- initialize (re-query nodes + proactive check) ----
  Ajaxinate.prototype.initialize = function () {
    this.containerElement = document.querySelector(this.settings.container);
    this.paginationElement = document.querySelector(this.settings.pagination);

    if (!this.containerElement) return;

    var initializers = { click: this.addClickListener, scroll: this.addScrollListeners };
    initializers[this.settings.method]();

    if (this.settings.method === 'scroll') {
      requestAnimationFrame(() => {
        try { this.checkIfPaginationInView(); } catch (_) {}
      });
    }

    document.dispatchEvent(new CustomEvent('ajaxinate:after'));
  };

  // ---- checkIfPaginationInView ----
  Ajaxinate.prototype.checkIfPaginationInView = function () {
    this.paginationElement = document.querySelector(this.settings.pagination);
    if (!this.paginationElement) return;

    const rect = this.paginationElement.getBoundingClientRect();
    const top = rect.top - this.settings.offset;
    const bottom = rect.bottom + this.settings.offset;
    const inView = top <= window.innerHeight && bottom >= 0;

    const link = this.paginationElement.querySelector('a');

    if (inView) {
      this.nextPageLinkElement = link;
      this.removeScrollListener();

      if (this.nextPageLinkElement) {
        this.nextPageLinkElement.innerText = this.settings.loadingText;
        this.nextPageUrl = this.nextPageLinkElement.href;
        this.loadMore();
      }
    }
  };

  // ---- loadMore (guarantee re-init) ----
  Ajaxinate.prototype.loadMore = function () {
    var self = this;
    this.request = new XMLHttpRequest();

    this.request.onreadystatechange = function () {
      if (self.request.readyState === 4 && self.request.status === 200) {
        try {
          var doc = self.request.responseXML;
          var newContainer = doc.querySelector(self.settings.container);
          var newPagination = doc.querySelector(self.settings.pagination);

          if (newContainer) self.containerElement.insertAdjacentHTML('beforeend', newContainer.innerHTML);
          if (newPagination) self.paginationElement.innerHTML = newPagination.innerHTML;

          try {
            if (self.settings.callback && typeof self.settings.callback === 'function') {
              self.settings.callback(self.request.responseXML);
            }
          } catch (_) {} 
          finally {
            self.initialize();
          }
        } catch (_) {
          try { self.initialize(); } catch (_) {}
        }
      }
    };

    this.request.open('GET', this.nextPageUrl);
    this.request.responseType = 'document';
    this.request.send();
  };
})();
